import { Injectable, inject } from '@angular/core';
import { TrackingEvent } from '../../enums/tracking-event/tracking-event.enum';
import { AbstractTrackingService } from 'shared/core/data-access/analytics-types';
import { PayloadFor } from '../../models/tracking-event-data/tracking-event-data.model';
import { ResourceViewSource } from '../../enums/resource-view-source/resource-view-source.enum';

@Injectable({
    providedIn: 'root',
})
export class TrackingService {
    #trackingService = inject(AbstractTrackingService);
    #previousUrl = '';
    #pendingViewSource?: ResourceViewSource;

    get previousUrl(): string {
        return this.#previousUrl;
    }

    setPreviousUrl(url: string) {
        this.#previousUrl = url;
    }

    recordViewSource(source: ResourceViewSource) {
        this.#pendingViewSource = source;
    }

    consumeViewSource(): ResourceViewSource | undefined {
        const source = this.#pendingViewSource;
        this.#pendingViewSource = undefined;
        return source;
    }

    trackEvent<T extends TrackingEvent>(event: T, data: PayloadFor<T>) {
        this.#trackingService.trackEvent(event, data);
    }
}
